import React from "react";
import "./ErrorPopup.css";

function ErrorPopup(props) {
  return props.trigger ? (
    <div className="popup" onClick={() => props.setTrigger(false)}>
      <div className="popup-inner-error">{props.children}</div>
    </div>
  ) : (
    ""
  );
}

export default ErrorPopup;
